import { inject, injectable } from 'inversify'
import { SERVICE_TYPES } from '@/core/container/types'
import type { Resolvable } from '@/services/resolvers/types'
import type GettingStartedInfoService from '@/services/domain/gettingStartedInfoService'

@injectable()
export default class GettingStartedInfoResolverService implements Resolvable {
  constructor(
    @inject(SERVICE_TYPES.GettingStartedInfoService)
    protected readonly gettingStartedInfoService: GettingStartedInfoService,
  ) {}

  public async resolve() {
    await this.gettingStartedInfoService.findOrFillInfo()
  }
}
